import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Clock } from 'lucide-react';
import { Button } from '../components/ui/button';

const AuthCallback = () => {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { loginWithGoogle } = useAuth();
  const [pendingApproval, setPendingApproval] = useState(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const params = new URLSearchParams(hash.substring(1));
    const sessionId = params.get('session_id');

    if (!sessionId) {
      navigate('/login', { replace: true });
      return;
    }

    loginWithGoogle(sessionId).then(result => {
      if (result.success && result.pending) {
        setPendingApproval(true);
      } else if (result.success) {
        window.history.replaceState(null, '', '/dashboard');
        navigate('/dashboard', { replace: true });
      } else {
        navigate('/login', { state: { error: result.error }, replace: true });
      }
    });
  }, []);

  if (pendingApproval) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#0d6571] to-[#0d6571]/80 px-4">
        <div className="bg-white rounded-2xl shadow-2xl p-12 text-center max-w-md" data-testid="google-pending-approval">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-amber-100 rounded-full mb-6">
            <Clock className="w-10 h-10 text-amber-600" />
          </div>
          <h1 className="text-2xl font-bold text-gray-900 mb-4">Account Pending Approval</h1>
          <p className="text-gray-600 mb-6">
            Your Google account has been registered and is awaiting admin approval.
          </p>
          <Button onClick={() => navigate('/login', { replace: true })} className="bg-[#0d6571] hover:bg-[#0d6571]/90 text-white rounded-full px-8 py-3 font-semibold">
            Go to Login
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#0d6571] to-[#0d6571]/80">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-white mx-auto"></div>
        <p className="mt-4 text-white text-lg" data-testid="google-auth-loading">Signing you in with Google...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
